type Props = {
  children: React.ReactNode;
  labels: Array<{ key: string; label: string }>;
  onSelectedTabChange: (key: string) => void;
  showViewLabels: boolean;
  selectedTab: string;
};

export function ViewContainer({
  children,
  labels,
  onSelectedTabChange,
  showViewLabels,
  selectedTab,
}: Props) {
  return (
    <div>
      {showViewLabels ? (
        <div className="flex space-x-4">
          {labels.map((tab) => {
            const isActiveTab = tab.key === selectedTab;
            return (
              <button
                key={tab.key}
                className={`cursor-pointer p-4 font-semibold ${isActiveTab ? 'text-tab-active' : 'text-tab-inactive'}`}
                data-testid={`cd-tab-${tab.key}`}
                onClick={() => onSelectedTabChange(tab.key)}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      ) : null}
      {children}
    </div>
  );
}
